import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import OtpModal from "./OtpModal";

const ProtectedRoutePage = ({ Component }) => {
  const [allowed, setAllowed] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
  const hasRequestedOtp = useRef(false);
  const route = location.pathname;

  useEffect(() => {
    const adminToken = localStorage.getItem("adminToken");

    if (adminToken) {
      try {
        const decoded = jwtDecode(adminToken);
        if (decoded.role === "admin") {
          setAllowed(true); // Bypass OTP if admin
          return;
        }
      } catch (err) {
        console.error("Invalid adminToken");
      }
    }

    // Non-admins go through OTP flow
    const otpToken = sessionStorage.getItem(`otpToken_${route}`);
    if (!otpToken && !hasRequestedOtp.current) {
      sendOtp(route);
      hasRequestedOtp.current = true;
      setShowModal(true);
    } else if (otpToken) {
      validateToken(otpToken, route);
    }
  }, [route]);

  const sendOtp = async (route) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/otp/send-otp`,
        { route }
      );
    } catch (err) {
      console.error("OTP send failed:", err);
    }
  };

  const validateToken = async (token, route) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/otp/validate-access`,
        { token, route }
      );
      if (res.data.allowed) {
        setAllowed(true);
      } else {
        sessionStorage.removeItem(`otpToken_${route}`);
        setShowModal(true);
      }
    } catch (err) {
      console.error("Token validation error:", err);
    }
  };

  const handleOtpVerified = (token) => {
    sessionStorage.setItem(`otpToken_${route}`, token);
    setAllowed(true);
    setShowModal(false);
  };

  return allowed ? (
    <Component />
  ) : (
    <OtpModal open={showModal} onVerified={handleOtpVerified} />
  );
};

export default ProtectedRoutePage;
